import React from "react";

import { TextInput, required } from 'react-admin';

import { GridForm, GridInput } from '../../../components/GridForm';
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { CommodityCategory } from "entities/CommodityCategory";


export const CommoditiesForm = ({ isEditForm = false, ...props }) => (
	<GridForm {...props}>
		{isEditForm && <GridInput sm={2} component={TextInput} source="id" disabled />}
		<GridInput xs={12} sm={isEditForm ? 5 : 6} component={TextInput} source="name" validate={[required()]} />
		<GridInput sm={5} component={SelectEnumInput} source="category" enumName="commodity-category" enumObj={CommodityCategory} validate={[required()]} />
	</GridForm>
);
